import axios from '../axios';

export default {
  getDevices (options) {
    const params = {};
    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.include) {
      params.include = options.include;
    }

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/device?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getDevice (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/device/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  newDevice (params) {
    return new Promise((resolve, reject) => {
      axios.post('/device', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  newDeviceBarrier (params) {
    return new Promise((resolve, reject) => {
      axios.post('/barrier-device', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateDeviceBarrier (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/barrier-device/${data.id}`, { ...data.dataDevice })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  newDeviceController (params) {
    return new Promise((resolve, reject) => {
      axios.post('/controller-device', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateDeviceController (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/controller-device/${data.id}`, { ...data.dataDevice })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateDevice (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/device/${data.id}`, { ...data.dataDevice })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteDevice (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/device/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  exportCsv () {
    return new Promise((resolve, reject) => {
      axios.get('/device/export-csv', { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  updateFirmwareVersions () {
    return new Promise((resolve, reject) => {
      axios.put('/device/firmware-versions')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getDeviceInfo (ipAddress, type) {
    return new Promise((resolve, reject) => {
      axios.get(`/device/info?ip_address=${ipAddress}&type=${type}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getDeviceFreeSip () {
    return new Promise((resolve, reject) => {
      axios.get('/device/free-sip')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getDeviceFreeCityPhone () {
    return new Promise((resolve, reject) => {
      axios.get('/device/free-city-phone')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  newDeviceGsm (params) {
    return new Promise((resolve, reject) => {
      axios.post('/gsm-device', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateDeviceGsm (data) {
    return new Promise((resolve, reject) => {
      axios.put(`/gsm-device/${data.id}`, { ...data.dataDevice })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteDeviceGsm (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/gsm-device/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
